var React = require('react');

function RouterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 2.5H10v10h20v-10h2.5v10h5v20h-35v-20h5v-10zM35 15H5v15h30V15z","fill":"#fff"}));
}

RouterIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = RouterIcon;

RouterIcon.default = RouterIcon;
